import { tns } from 'tiny-slider/src/tiny-slider';
import scrollToElement from 'scroll-to-element';

/**
 * Hero Slider
 * @var heroSlider
 */
class HeroSlider {
  /**
   * Constructor
   */
  constructor() {
    this.hero = document.querySelector('.hero');
    this.sections = document.querySelectorAll('section:not(.hero) h4');
    this.anchorsContainer = document.querySelector('.hero__anchors');
    this.heroSlider = this.hero.querySelector('.hero__slider');
    this.heroSlide = this.hero.querySelectorAll('.hero__slide');
    this.heroNav = this.hero.querySelector('.hero__nav');
    this.prevButton = this.hero.querySelector('.hero__prev');
    this.nextButton = this.hero.querySelector('.hero__next');
    this.slider = {};
  }

  /**
   * Init
   */
  init() {
    if (this.isSlider()) {
      this.initSlider();
    } else {
      this.initAnchor();
    }
  }

  /**
   * Is Slider
   * @return boolean return true if more than one slide
   */
  isSlider() {
    return this.hero.classList.contains('hero--slider');
  }

  /**
   * Init the slider
   */
  initSlider() {
    this.slider = tns({
      container: this.heroSlider,
      mode: 'gallery',
      swipeAngle: false,
      speed: 400,
      navContainer: this.heroNav,
      prevButton: this.prevButton,
      nextButton: this.nextButton,
    });
  }

  /**
   * Init anchor
   */
  initAnchor() {
    this.sections.forEach(item => {
      const section = item.closest('section');
      const { id } = section;

      const button = document.createElement('a');
      button.setAttribute('href', `#${id}`);
      button.classList.add('btn', 'white', 'space-mr-2', 'btn--anchor');
      button.innerHTML = item.innerHTML;

      this.anchorsContainer.appendChild(button);

      HeroSlider.scrollTo(button, section);
    });
  }

  /**
   * Scrool to
   */
  static scrollTo(link, target) {
    link.addEventListener('click', e => {
      e.preventDefault();
      scrollToElement(target, {
        ease: 'out-expo',
        duration: 1000,
      });
    });
  }
}

const heroSlider = new HeroSlider();
heroSlider.init();
